// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  padding-left: var(--space-content-left);
  padding-right: var(--space-content-right);
  padding-top: var(--space-content-top);
  padding-bottom: var(--space-content-bottom);
}
@media only screen and (min-width: 768px) {
  :host {
    width: 50%;
    left: unset;
    right: 0;
    padding-left: var(--space-content-left-medium-screen);
    padding-right: var(--space-content-right-medium-screen);
    padding-top: var(--space-content-top-medium-screen);
    padding-bottom: var(--space-content-bottom-medium-screen);
    background-color: var(--color-surface);
  }
}
@media only screen and (min-width: 1240px) {
  :host {
    padding-left: var(--space-content-left-large-screen);
  }
}
@media only screen and (min-width: 1288px) {
  :host {
    padding-right: calc(50% - 644px + var(--space-content-right-large-screen));
  }
}
:host .social_login_content {
  display: flex;
  height: 100%;
  flex-direction: column;
}
@media only screen and (min-width: 768px) {
  :host .social_login_content {
    gap: 13%;
  }
}
@media only screen and (min-width: 768px) {
  :host .social_login_buttons-content {
    margin-bottom: auto;
  }
}
:host .social_login_title-content {
  flex-grow: 1;
}
@media only screen and (min-width: 768px) {
  :host .social_login_title-content {
    flex-grow: 0;
    margin-top: auto;
  }
}
:host .social_login_title-content .social_login_title {
  text-align: center;
  margin-bottom: 20px;
}
:host .social_login_hr {
  width: 100%;
  display: flex;
  flex-direction: row;
  text-transform: uppercase;
  border: none;
  margin-top: 22px;
  margin-bottom: 22px;
}
:host .social_login_hr:before, :host .social_login_hr:after {
  content: "";
  border-bottom: 1.5px solid #c2c8d0;
  flex: 1 0 auto;
  height: 0.7em;
}
:host .social_login_hr span {
  text-align: center;
  flex: 0.2 0 auto;
}
:host .social_login_buttons ::ng-deep app-buttons-footer .footer-content {
  --flex-flow: column nowrap;
  --gap: 22px;
  --app-space-content-top: 0;
  --app-space-content-right: 0;
  --app-space-content-bottom: 0;
  --app-space-content-left: 0;
}
@media only screen and (min-width: 768px) {
  :host .social_login_buttons ::ng-deep app-buttons-footer .footer-content {
    background-color: var(--color-surface);
  }
}
:host .buttons-default-content ::ng-deep app-buttons-footer .footer-content {
  --app-space-content-top: 0;
  --app-space-content-right: 0;
  --app-space-content-left: 0;
}
@media only screen and (min-width: 768px) {
  :host .buttons-default-content ::ng-deep app-buttons-footer .footer-content {
    background-color: var(--color-surface);
  }
}
:host .buttons-default-content ::ng-deep app-buttons-footer .appointment-button-default {
  --color: #969696;
  --border-color: #969696;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/skeleton-social-login/skeleton-social-login.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EAEA,uCAAA;EACA,yCAAA;EACA,qCAAA;EACA,2CAAA;AAAJ;AAEI;EAZJ;IAaQ,UAAA;IACA,WAAA;IACA,QAAA;IAEA,qDAAA;IACA,uDAAA;IACA,mDAAA;IACA,yDAAA;IACA,sCAAA;EAAN;AACF;AAEI;EAxBJ;IAyBQ,oDAAA;EACN;AACF;AACI;EA5BJ;IA6BQ,0EAAA;EAEN;AACF;AAEI;EACI,aAAA;EACA,YAAA;EACA,sBAAA;AAAR;AAEQ;EALJ;IAMQ,QAAA;EACV;AACF;AAGQ;EADJ;IAEQ,mBAAA;EAAV;AACF;AAEI;EACI,YAAA;AAAR;AACQ;EAFJ;IAGQ,YAAA;IACA,gBAAA;EAEV;AACF;AAAQ;EACI,kBAAA;EACA,mBAAA;AAEZ;AAEI;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;AAAR;AACQ;EAEI,WAAA;EACA,kCAAA;EACA,cAAA;EACA,aAAA;AAAZ;AAEQ;EACI,kBAAA;EACA,gBAAA;AAAZ;AAMY;EACI,0BAAA;EACA,WAAA;EACA,0BAAA;EACA,4BAAA;EACA,6BAAA;EACA,2BAAA;AAJhB;AAKgB;EAPJ;IAQQ,sCAAA;EAFlB;AACF;AASY;EACI,0BAAA;EACA,4BAAA;EACA,2BAAA;AAPhB;AAQgB;EAJJ;IAKQ,sCAAA;EALlB;AACF;AAQY;EACI,gBAAA;EACA,uBAAA;AANhB","sourcesContent":[":host {\r\n    height: 100%;\r\n    width: 100%;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n\r\n    padding-left: var(--space-content-left);\r\n    padding-right: var(--space-content-right);\r\n    padding-top: var(--space-content-top);\r\n    padding-bottom: var(--space-content-bottom);\r\n\r\n    @media only screen and (min-width: 768px) {\r\n        width: 50%;\r\n        left: unset;\r\n        right: 0;\r\n\r\n        padding-left: var(--space-content-left-medium-screen);\r\n        padding-right: var(--space-content-right-medium-screen);\r\n        padding-top: var(--space-content-top-medium-screen);\r\n        padding-bottom: var(--space-content-bottom-medium-screen);\r\n        background-color: var(--color-surface);\r\n    }\r\n\r\n    @media only screen and (min-width: 1240px) {\r\n        padding-left: var(--space-content-left-large-screen);\r\n    }\r\n\r\n    @media only screen and (min-width: 1288px) {\r\n        padding-right: calc(\r\n            calc(50% - 644px) + var(--space-content-right-large-screen)\r\n        );\r\n    }\r\n\r\n    .social_login_content {\r\n        display: flex;\r\n        height: 100%;\r\n        flex-direction: column;\r\n\r\n        @media only screen and (min-width: 768px) {\r\n            gap: 13%;\r\n        }\r\n    }\r\n\r\n    .social_login_buttons-content {\r\n        @media only screen and (min-width: 768px) {\r\n            margin-bottom: auto;\r\n        }\r\n    }\r\n    .social_login_title-content {\r\n        flex-grow: 1;\r\n        @media only screen and (min-width: 768px) {\r\n            flex-grow: 0;\r\n            margin-top: auto;\r\n        }\r\n\r\n        .social_login_title {\r\n            text-align: center;\r\n            margin-bottom: 20px;\r\n        }\r\n    }\r\n\r\n    .social_login_hr {\r\n        width: 100%;\r\n        display: flex;\r\n        flex-direction: row;\r\n        text-transform: uppercase;\r\n        border: none;\r\n        margin-top: 22px;\r\n        margin-bottom: 22px;\r\n        &:before,\r\n        &:after {\r\n            content: '';\r\n            border-bottom: 1.5px solid #c2c8d0;\r\n            flex: 1 0 auto;\r\n            height: 0.7em;\r\n        }\r\n        span {\r\n            text-align: center;\r\n            flex: 0.2 0 auto;\r\n        }\r\n    }\r\n\r\n    .social_login_buttons {\r\n        ::ng-deep app-buttons-footer {\r\n            .footer-content {\r\n                --flex-flow: column nowrap;\r\n                --gap: 22px;\r\n                --app-space-content-top: 0;\r\n                --app-space-content-right: 0;\r\n                --app-space-content-bottom: 0;\r\n                --app-space-content-left: 0;\r\n                @media only screen and (min-width: 768px) {\r\n                    background-color: var(--color-surface);\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .buttons-default-content {\r\n        ::ng-deep app-buttons-footer {\r\n            .footer-content {\r\n                --app-space-content-top: 0;\r\n                --app-space-content-right: 0;\r\n                --app-space-content-left: 0;\r\n                @media only screen and (min-width: 768px) {\r\n                    background-color: var(--color-surface);\r\n                }\r\n            }\r\n\r\n            .appointment-button-default {\r\n                --color: #969696;\r\n                --border-color: #969696;\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
